import { c as _c } from "react/compiler-runtime";
import { LayoutContainer } from '@petsmart-ui/sparky';
import cn from 'classnames';
import type { ContainerProps } from './types';
import './container.scss';
export type { ContainerProps } from './types';
export function Container(t0) {
  const $ = _c(5);
  const {
    roundTopCorners,
    children
  } = t0;
  let t1;
  if ($[0] !== roundTopCorners) {
    t1 = cn("resolver-container", {
      "resolver-container--rounded-top": roundTopCorners
    });
    $[0] = roundTopCorners;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <LayoutContainer className={t1}>{children}</LayoutContainer>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}